// Trainer-timezone-aware date helpers. tz is an IANA zone (e.g. "Asia/Hong_Kong")
// or null/undefined -> fall back to the device zone (today's behavior).

export function deviceZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/** Local calendar day 'YYYY-MM-DD' for an ISO instant, in the given zone. */
export function localDayInZone(iso: string, tz?: string | null): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz || deviceZone(),
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
  return parts; // en-CA yields YYYY-MM-DD
}

/** Display a date-time in the given zone (fallback device zone). */
export function formatInZone(
  iso: string,
  tz?: string | null,
  opts: Intl.DateTimeFormatOptions = { dateStyle: "medium", timeStyle: "short" },
): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat(undefined, {
    timeZone: tz || deviceZone(),
    ...opts,
  }).format(d);
}
